import React from 'react';
import Header from '../../../../Header';
import Footer from '../../../../Footer';
import EbidtaCalculator from './EbidtaCalculator';

const EbidtaInfo = () => {
  return (
    <div className="bg-[#FFFFFF] rounded-lg shadow-lg p-6">
      <h2 className="text-[#1C52A0] text-2xl font-semibold mb-4">EBITDA Margin Calculator</h2>
      <p className="mb-4 text-[#0D0D0D]">The EBITDA Margin Calculator helps you measure your company's operating profitability. It provides a quick and accurate assessment of how efficiently your business generates profit from its core operations, helping you make informed financial decisions.</p>

      <h3 className="text-[#1C52A0] text-xl font-semibold mb-3">Key Components</h3>
      <ul className="list-disc pl-6 mb-4 text-[#0D0D0D]">
        <li>Earnings Before Interest, Taxes, Depreciation, and Amortization (EBITDA)</li>
        <li>Revenue</li>
        <li>Operating Expenses</li>
        <li>Depreciation</li>
        <li>Amortization</li>
      </ul>

      <h3 className="text-[#1C52A0] text-xl font-semibold mb-3">How It Works</h3>
      <p className="mb-4 text-[#0D0D0D]">The calculator uses a comprehensive approach to determine your EBITDA margin:</p>
      <ul className="list-disc pl-6 mb-4 text-[#0D0D0D]">
        <li>Calculates EBITDA by adding back non-operating expenses</li>
        <li>Compares EBITDA with total revenue</li>
        <li>Calculates the EBITDA margin percentage</li>
        <li>Provides industry benchmarks for comparison</li>
        <li>Generates detailed profitability analysis</li>
      </ul>

      <h3 className="text-[#1C52A0] text-xl font-semibold mb-3">Benefits</h3>
      <ul className="list-disc pl-6 mb-4 text-[#0D0D0D]">
        <li>Measure operational efficiency</li>
        <li>Compare with industry standards</li>
        <li>Identify cost reduction opportunities</li>
        <li>Assess financial health</li>
        <li>Support investment decisions</li>
      </ul>

      <h3 className="text-[#1C52A0] text-xl font-semibold mb-3">Using the Calculator</h3>
      <p className="mb-4 text-[#0D0D0D]">Enter your company's revenue and operating expenses to calculate the EBITDA margin. The calculator will provide a detailed analysis of your operating profitability and how it compares to industry standards.</p>
    </div>
  );
};

const Ebidta = () => {
  return (
    <>
      <Header/>
      <main className="overflow-x-hidden">
        <div className="relative z-20">
          <EbidtaCalculator/>
        </div>
        <EbidtaInfo />
      </main>
      <div className="relative z-20">
        <Footer />
      </div>
    </>
  );
};

export default Ebidta;